import globals from "../partials/global-variables";
import { ButtonPrimary } from "../partials/buttons";
import stylesConfig from "../styles.config";

export default {
  container: {
    textAlign: "right",
    padding: "25px 0",
    "& button": {
      ...ButtonPrimary,
      margin: "0px",
      minWidth: "unset",
      borderRadius: "0 25px 25px 0",
      border: "none",
      padding: "0 20px",
    },
    "& .input-wrapper": {
      border: "1px solid",
      borderColor: stylesConfig.colors.secondary.spectrum100,
      width: "100%",
      padding: ["8px", "5px", "8px", "5px"],
      backgroundColor: globals.colors.white,
      borderRadius: "25px 0 0 25px",
    },
    "& input": {
      width: "100%",
      background: "transparent",
      border: 0,
      fontSize: "14px",
      height: "31px",
      padding: "0 15px",
      outline: 0,
    },
    "& .search-wrapper": {
      width: "60%",
      display: "flex",
      margin: "0 auto",
    },
  },
};
